import { user } from '@/Services/Axios'
import { facilita } from '@/global'

const state = {
    user: {},
}

const getters = {
    user: (state) => state.user,
}

const actions = {
    async setUser({ commit }) {
        const response = await user.get('', facilita.userID, {})
        if(response.data.status === 'inactive') {
            return this.$router.push( {name:'NotFound'})
        }
        commit('SET_USER', response.data)
    },
}

const mutations = {
    SET_USER: (state, payload) => (state.user = payload),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
